const API_PREFIX = '/geojson/';

export const fetchFootprint = (name) => {
  return fetch(API_PREFIX + name + '/0.json').then(response => {
    return response.json().then(json => {
      if (response.ok) return json;
      return Promise.reject(json);
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/footprints.js